import React, { useState, useEffect, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { useAuthProvider } from 'ra-core';
import Typography from '@material-ui/core/Typography';
import ChangeLevel from './changelevel'
import IconButton from '@material-ui/core/IconButton';
import {
    Box, Grid, Card, ListItem,
    CardContent, Button, Collapse, Avatar, CircularProgress
} from '@material-ui/core';
import {
    useMediaQuery, FormControlLabel
} from '@material-ui/core';
import { Link } from "react-router-dom";
import { useTranslate, Title, useDataProvider, usePermissions } from 'react-admin';
import colors from '../CustomizedUIs/Colors';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import { baseApiUrl } from '../dataProvider/sails';
import UpdatePassword from './updatepassword';
import ChangePassword from './changepassword';
import { Alert } from '@material-ui/lab';
import IconTitle from './iconTitle';
import AcceptDelete from './acceptdelete';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import Error from '../CustomizedUIs/Error'
import bin from '../assets/icons/primary-blue-bin.png';
import edit from '../assets/icons/ic_content_management_light.png';
import CustomPoperUser from './CustomPoperUser';
import CustomSwitch from '../CustomizedUIs/GreenSwitch'
import CustomTextField from './CustomTextField'
import Loading from '../common/loading-page';
import TextButton from '../CustomizedUIs/TextButton';

let cancel = [];
const useStyles = makeStyles(theme => ({
    searchPaper: {
        padding: '4px 2px',
        display: 'flex',
        alignItems: 'center',
        margin: 'auto 0',
    },
    iconButton: {
        padding: 10,
    },
    large: {
        width: theme.spacing(12),
        height: theme.spacing(12),
    },
    underline: {
        '&::before': {
            borderBottom: '1px solid black'
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid black'
        }
    },
    underlineNotValue: {
        '&::before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        },
        '&:hover:not($disabled):before': {
            borderBottom: '1px solid' + colors.lightBlue['200']
        }
    },
    focuses: {
        backgroundColor: 'white !important'
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    expandGroup: {
        height: 30,
        float: 'right',
        borderRadius: '4px',
        backgroundColor: ' #ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around'
    },
    expandText: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#4f5064',
        textAlign: 'center',
        padding: '5px 8px 5px 8px'

    },
    display: {
        display: 'none',
    },
    input: {
        backgroundColor: 'white',
        borderRadius: '2px',
        "&:hover": {
            backgroundColor: 'white'
        },
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    number: {
        "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
            "-webkit-appearance": "none",
            margin: 0
        },
        " & input[type=number] ": {
            "-moz-appearance": "textfield",
        }
    },
    TitleCreate: {
        fontFamily: 'UniviaPro',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    textForce: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#4f5064',
    },
    borderForce: {
        width: '25.5px',
        height: '10.5px',
        backgroundColor: '#b4b5bd',
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TitleLevel: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    borderLevel: {
        borderRadius: '10px',
        border: ' solid 1px #e0f0f2',
        backgroundColor: ' #fafefe',
    },
    textLevel: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#6cb5b8',
        textAlign: 'center'
    },
    textbtnLevel: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    TitleImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
        paddingBottom: '20px'
    },
    borderImage: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        '&:hover': {
            backgroundColor: '#a7cce7',
        }
    },
    textBtnImage: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#237fc2',
        padding: '8px',

    },
    textRequired: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: 'rgba(0, 0, 0, 0.54)',
    },
    textRequiredStar: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.36,
        letterSpacing: 'normal',
        color: '#e1503a',
    },

    btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '5px'
    },
    btnClose: {
        borderRadius: '12px',
        border: 'solid 1.2px #e0f0f2',
        backgroundColor: '#ffffff',
    },
    textClose: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '10px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.4px',
        color: '#237fc2',
    },
    textDelete: {
        fontFamily: 'UniviaPro',
        fontSize: '10px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.4px',
        color: '#237fc2',
    },
    borderUpImange: {
        width: '500px',
        height: ' 145px',
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: ' #ffffff',
    },
    btnUpdatePassword: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '8px',
    },
    boderUpdatePassword: {
        borderRadius: '10px',
    },
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
}))


export const EditUser = (props) => {
    const authProvider = useAuthProvider();
    const [notPermission, setNotPermission] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [openDialog1, setOpenDialog1] = useState(false);
    const dataProvider = useDataProvider();
    const [data, setData] = useState([]);
    const history = useHistory();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const translate = useTranslate();
    const classes = useStyles();
    const [dataRole, setDataRole] = useState([]);
    const [dataLanguage, setDataLanguage] = useState([]);
    const [role, setRole] = useState("");
    const [roleId, setRoleId] = useState("");
    const [openRole, setOpenRole] = useState(false);
    const [openLanguage, setOpenLanguage] = useState(false);
    const [language, setLanguage] = useState('');
    const [languageId, setLanguageId] = useState();
    const [languagecode, setLanguageCode] = useState('');
    const [image, setImage] = useState('');
    const [inActive, setInActive] = useState(false);
    const [isSend, setIsSend] = useState(false);
    const [message, setMessage] = useState("");
    const [openAlert, setOpenAlert] = useState(false);
    const [entities, setEntities] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [cluster, setCluster] = useState([]);
    const [countcluster, setCountCluster] = useState("");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [expandAll, setExpandAll] = useState(false);
    const [roleUser, setRoleUser] = useState()
    const [mobileApp, setMobileApp] = useState(false);
    const [videoCall, setVideoCall] = useState(false);
    const { permissions, loaded } = usePermissions();
    const [textValue, setTextValue] = React.useState({
        username: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        phoneNumber: '',
        organisation: '',
        passwordInput: '',
        passwordNewInput: '',
        passwordConformInput: '',
    });
    const [validate, setValidate] = React.useState({
        lastName: {
            isError: true,
            message: ''
        },
        number: {
            isError: true,
            message: ''
        },
        username: {
            isError: true,
            message: ''
        },
        firstName: {
            isError: true,
            message: ''
        }, email: {
            isError: true,
            message: ''
        },
        password: {
            isError: true,
            message: ''
        },
        phoneNumber: {
            isError: true,
            message: ''
        },
        organisation: {
            isError: true,
            message: ''
        },
    });

    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        validateFc(prop, e.target.value)
    }

    const validateFc = (prop, value) => {
        if (prop === 'username') {
            if (value.length === 0)
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                            isError: false, message: ''
                        }
                })
            else {
                setValidate({
                    ...validate, [prop]: value.length > 50 ? {
                        isError: true, message: ' Input < 50 characters'
                    } : {
                            isError: false, message: ''
                        }
                })
            }
        }
        else if (prop === 'email') {
            if (value.length === 0)
                setValidate({
                    ...validate, [prop]: value.length === 0 ? {
                        isError: true, message: 'required'
                    } : {
                            isError: false, message: ''
                        }
                })
            else {
                setValidate({
                    ...validate, [prop]: ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(value)) === true ? {
                        isError: false, message: ''
                    } : {
                            isError: true, message: translate('pos.auth.emailIncorrect')
                        }
                })

            }
        }
        else
            setValidate({
                ...validate, [prop]: value.length === 0 ? {
                    isError: true, message: 'required'
                } : {
                        isError: false, message: ''
                    }
            })

    }

    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    // const theme = useSelector((state) =>
    //     state.theme === 'dark' ? darkTheme : lightTheme
    // );


    const handleOpenDialog = () => {
        cancel = entities.map(item => ({
            ...item
        }));
        setOpenDialog(true)
    }
    const preventDefault1 = () => {
        setOpenDialog1(true)
    }


    //event input user
    // event select language
    const handleClickOpenLanguage = () => {
        setOpenLanguage(!openLanguage)
    }
    const onChangeLanguage = (language) => {
        setLanguage(language.name)
        setLanguageId(language.id)
        setLanguageCode(language.code)
        setOpenLanguage(false)
    }
    // event select role
    const handleClickOpenRole = () => {
        setOpenRole(!openRole)
    }
    const onChangeRole = (role) => {
        setRole(role.name)
        setRoleId(role.id)
        setOpenRole(false)
    }
    const handleChooseImage = (e) => {
        const form = new FormData();
        form.append('avatar', e.target.files[0]);
        dataProvider('UPLOAD', 'user/upload', form).then(({ data }) => {
            setImage(data.fileName);
        }).catch(error => {
            console.log('handleChooseImage error:', error)
        });
    }
    const handleInActive = () => {
        setInActive(true)
    }
    const handleOpenAccept = () => {
        setOpen(true);
    }
    const handleClosePoper = () => {
        setOpenPopper(false);
    };
    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleDelete = () => {
        dataProvider('DELETE', 'users', {
            id: data.id

        }).then((data) => {

            history.push({
                pathname: '/users',
                state: { openEdit: true }
            });
        }).catch(error => {
            // TODO: Should show error message
            console.log('Submit user error:', error);
        });
    };

    const handleChange = (e) => {
        setInActive(e.target.checked);
    };

    const handleChangeMobileAppSwitch = (e) => {
        setMobileApp(e.target.checked);
        if (e.target.checked === false)
            setVideoCall(false)
    };

    const handleChangeVideoCallSwitch = (e) => {
        if (mobileApp)
            setVideoCall(e.target.checked);
    };

    const handleSendMail = forceUser => {
        dataProvider('CREATE', 'changepassword', {
            data: {
                email: data.email,
                force: forceUser
            }

        }).then((response) => {
            if (response.success) {
                setIsSend(true);
                setOpenDialog1(true);
            }

        })
            .catch((e) => {
                setIsSend(false);
                setMessage(translate('pos.auth.sendMailError'));
                setOpenAlert(true);

            });
    };

    const handleShowCluster = (data) => {
        let clusterName = [];
        data.levels.forEach(entity => {
            entity.groups.forEach(group => {
                group.clusters.forEach(cluster => {
                    if (cluster.checked) {
                        clusterName.push(cluster.name);
                    }
                })
            });
        });
        setCluster(clusterName);
        setCountCluster(clusterName.length);
    }

    const handleSaveShowCluster = () => {
        let nameCluster = [];
        entities.forEach(entity => {
            entity.groups.forEach(group => {
                group.clusters.forEach(cluster => {
                    if (cluster.checked) {
                        nameCluster.push(cluster.name)
                    }
                })
            });
        });
        setCluster(nameCluster);
        setCountCluster(nameCluster.length);
    }

    const handleSubmitUser = () => {
        setLoading(true);
        const clusterIds = [];

        entities.forEach(entity => {
            entity.groups.forEach(group => {
                group.clusters.forEach(cluster => {
                    if (cluster.checked) {
                        clusterIds.push(cluster.id);
                    }
                })
            });
        });
        dataProvider('UPDATE', 'users', {
            id: props.match.params.id,
            data: {
                email: textValue.email,
                username: textValue.username,
                organisation: textValue.organisation,
                firstName: textValue.firstName,
                lastName: textValue.lastName,
                role: roleId,
                language: languageId,
                phoneNumber: textValue.phoneNumber,
                isActive: !inActive,
                isLdap: true,
                avatarURL: image,
                levels: clusterIds,
                mobileApp: mobileApp,
                videoCall: videoCall,
            }
        }).then(({ users }) => {
            history.push({
                pathname: '/users',
                state: { open: true, name: textValue.username, }
            });
        }).catch(response => {
            // TODO: Should show error message
            if (response.message === 'permissionIncorect') {
                setNotPermission(true)
            }
            window.scrollTo(0, 0);
            setIsSend(false);
            setOpenAlert(true)
            setLoading(false)
            setMessage(translate(response.message));
        });

    };

    useEffect(() => {
        dataProvider('GET_ONE', "users", { id: props.match.params.id },
        )
            .then(({ data }) => {
                setTextValue(data)
                setData(data);
                setRole(data.role.name);
                setRoleId(data.role.id);
                setLanguage(data.language.name);
                setLanguageId(data.language.id);
                setLanguageCode(data.language.code);
                setImage(data.avatarURL);
                setInActive(!data.isActive);
                if (data.notChangeCluster)
                data.levels.map(entity => {
                    entity.checked = false
                    entity.groups.map(group => {
                        group.checked = false
                        group.clusters.map(cluster => {
                            cluster.checked = false
                        })
                    });
                });
                setEntities(data.levels);
                handleShowCluster(data);
                setMobileApp(data.mobileApp);
                setVideoCall(data.videoCall);

                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });

        dataProvider('GET_LIST', "rolesList", {
            filter: {},
            pagination: {},
            sort: {},

        })
            .then(({ data }) => {
                setDataRole(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            });
        dataProvider('GET_LIST', "language", {
            filter: {

            },
            pagination: {},
            sort: { field: 'id', order: 'ASC' },

        })
            .then(({ data }) => {
                setDataLanguage(data);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
            })
    }, []);

    React.useEffect(() => {
        if (localStorage.getItem('userData')) {
            var data = JSON.parse(localStorage.getItem('userData'))
            setRoleUser(data.permission.name)
        }
    }, []);

    if (notPermission) return <Error />
    if (loading) return <Loading show={true} />;
    if (error) return null;
    if (!dataRole) return null;
    if (!loaded) return null
    return (
        <Box width='100%' >
            <Title title={translate(`pos.user.title`)} />
            <Box width={!isDesktop ? '95%' : '80%'} m='auto'>
                <IconTitle
                    TitleBack={translate(`pos.user.back`)}
                    TitleName=''
                    pathName='/users'
                />
                <Box display='flex' width='100%' justifyContent='center'>
                    <Box my={2} style={{ width: '500px' }} >
                        <Typography className={classes.TitleCreate}>{translate(`pos.user.edit`) + data.username}</Typography>
                        <Box mt={3}>
                            <Collapse in={openAlert}>
                                <Alert severity={isSend ? "success" : "error"} >{message}</Alert>
                            </Collapse>
                        </Box>
                        {

                            (roleUser === "Sysadmin" || permissions.functionAction.find(value => value.function === 'Admin rights/functions' && value.isUpdate)) &&
                            <Box mt={2.25} display="flex" justifyContent='space-between' alignItems='center'>
                                <Box px={1} className={classes.expandGroup}  >
                                    <Typography className={classes.expandText} onClick={handleInActive}>{translate(`pos.user.setuserinactive`)}</Typography>
                                    <CustomSwitch onChange={handleChange} checked={inActive} size="small" />
                                </Box>
                                <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                                    <IconButton disabled={(role === "Sysadmin" || roleUser === "Admin") ? true : false} className={classes.btnClose} style={{ marginLeft: '1em', padding: '8px', cursor: 'pointer' }} onClick={handleOpenAccept} >
                                        {/* <Delete color='primary' /> */}
                                        <img alt='' src={bin} style={{ width: "15px", height: 15 }} />
                                    </IconButton>
                                    <AcceptDelete handleopen={open} handleClose={() => { setOpen(false) }} handledelete={handleDelete} ContentText={translate(`pos.user.contentDelete`)} Tittle={translate(`pos.user.deleteuser`)} />
                                    <Typography style={{ marginLeft: '1em' }} className={classes.textDelete}> {translate(`pos.user.deleteuseredit`)}</Typography>
                                </Box>

                            </Box>

                        }
                        <Box mt={3}>
                            <CustomTextField
                                required
                                onBlur={() => {
                                    validateFc('userName', textValue.username)
                                }}
                                id="filled-basic"
                                label={translate(`pos.user.username`)}
                                value={textValue.username}
                                error={validate.username.message !== "" && validate.username.isError}
                                helperText={validate.username.message}
                                onChange={textOnChange('username')}
                                style={{ width: 500 }}
                                endDom={
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.user.TitleUsesName`)}
                                        content={translate(`pos.user.ConstentUserName`)}
                                        icon={<b>?</b>}
                                    />
                                }
                            />
                        </Box>
                        <Fragment>
                            <Box alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '260px', height: '36px', backgroundColor: '#ffffff' }} >
                                <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate(`pos.user.mobileAppUser`)}</Typography>
                                <FormControlLabel
                                    control={<CustomSwitch size="small" checked={mobileApp} onChange={handleChangeMobileAppSwitch} />}
                                    labelPlacement="start"
                                    variant="caption"
                                    style={{ margin: 0 }}
                                />
                            </Box>
                            <Box alignItems='center' display='flex' justifyContent='space-between' style={{ marginTop: "1em", borderRadius: '0', width: '260px', height: '36px', backgroundColor: '#ffffff' }} >
                                <Typography style={{ paddingLeft: '24px' }} className={classes.textForce} >{translate(`pos.user.enableVideoCall`)}</Typography>
                                <FormControlLabel
                                    control={<CustomSwitch size="small" checked={videoCall} onChange={handleChangeVideoCallSwitch} />}
                                    labelPlacement="start"
                                    variant="caption"
                                    style={{ margin: 0 }}
                                />
                            </Box>
                            {
                                (roleUser === "Sysadmin") ?
                                    <Box>
                                        <Button style={{ marginTop: "2em" }} color='primary' variant="contained" className={classes.boderUpdatePassword} onClick={preventDefault1}>
                                            <Typography className={classes.btnUpdatePassword}>{translate(`pos.user.updatepassword`)}</Typography>
                                        </Button>
                                        <UpdatePassword
                                            open={openDialog1}
                                            handleClose={() => {
                                                setOpenDialog1(false)
                                                setIsSend(false)
                                            }}
                                            handleSendMail={handleSendMail}
                                            data={data}
                                            isSend={isSend}
                                        >
                                        </UpdatePassword>
                                    </Box>
                                    : (props.match.params.id === localStorage.getItem('id') ?
                                        <Box>
                                            <Button style={{ marginTop: "2em" }} variant="contained" color='primary' className={classes.boderUpdatePassword} onClick={preventDefault1}>
                                                <Typography className={classes.btnUpdatePassword}>   {translate(`pos.user.changepassword`)}</Typography>
                                            </Button>
                                            <ChangePassword
                                                open={openDialog1}
                                                handleClose={() => {
                                                    setOpenDialog1(false)
                                                    setIsSend(false)
                                                }}
                                                id={props.match.params.id}
                                                setIsSend={setIsSend}
                                                setOpenAlert={setOpenAlert}
                                                setMessage={setMessage}
                                                // handleSendMail={() => { handleSendMail({ data }) }}
                                                data={data}
                                                isSend={isSend}
                                            >
                                            </ChangePassword>
                                        </Box> : (permissions.functionAction.find(value => value.function === 'Admin rights/functions' && value.isUpdate) &&
                                            <Box>
                                                <Button style={{ marginTop: "2em" }} variant="contained" color='primary' className={classes.boderUpdatePassword} onClick={preventDefault1}>
                                                    <Typography className={classes.btnUpdatePassword}>{translate(`pos.user.updatepassword`)}</Typography>
                                                </Button>
                                                <UpdatePassword
                                                    open={openDialog1}
                                                    handleClose={() => {
                                                        setOpenDialog1(false)
                                                        setIsSend(false)
                                                    }}
                                                    handleSendMail={handleSendMail}
                                                    data={data}
                                                    isSend={isSend}
                                                >
                                                </UpdatePassword>
                                            </Box>)
                                    )
                            }
                        </Fragment>

                        {
                            (roleUser === "Sysadmin" || permissions.functionAction.find(value => value.function === 'Admin rights/functions' && value.isUpdate)) &&
                            <Fragment>

                                <hr style={{ marginTop: "30px", marginBottom: '30px', borderTopColor: ' #e6e6eb' }} />

                                <CustomTextField
                                    required
                                    onBlur={() => {
                                        validateFc('firstName', textValue.firstName)
                                    }}
                                    id="filled-basic"
                                    label={translate(`pos.user.firstname`)}
                                    value={textValue.firstName}
                                    error={validate.firstName.message !== "" && validate.firstName.isError}
                                    helperText={validate.firstName.message}
                                    onChange={textOnChange('firstName')}
                                    style={{ width: 500 }}
                                    endDom={
                                        <CustomPoper
                                            open={openPoper}
                                            anchorEl={anchorEl}
                                            handleClick={handleClickOpenPoper}
                                            handleClose={handleClosePoper}
                                            title={translate(`pos.user.TitleFirstName`)}
                                            content={translate(`pos.user.ConstentFirstName`)}
                                            icon={<b>?</b>}
                                        />
                                    }
                                />

                                <Box mt={3}>
                                    <CustomTextField
                                        required
                                        onBlur={() => {
                                            validateFc('lastName', textValue.lastName)
                                        }}
                                        id="filled-basic"
                                        label={translate(`pos.user.lastname`)}
                                        value={textValue.lastName}
                                        error={validate.lastName.message !== "" && validate.lastName.isError}
                                        helperText={validate.lastName.message}
                                        onChange={textOnChange('lastName')}
                                        style={{ width: 500 }}
                                        endDom={
                                            <CustomPoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.user.TitleLastName`)}
                                                content={translate(`pos.user.ConstentLastName`)}
                                                icon={<b>?</b>}
                                            />
                                        }
                                    />
                                </ Box>
                                <Box mt={3}>
                                    <CustomTextField
                                        required
                                        onBlur={() => {
                                            validateFc('email', textValue.email)
                                        }}
                                        id="filled-basic"
                                        label={translate(`pos.user.email`)}
                                        value={textValue.email}
                                        error={validate.email.message !== "" && validate.email.isError}
                                        helperText={validate.email.message}
                                        onChange={textOnChange('email')}
                                        style={{ width: 500 }}
                                        endDom={
                                            <CustomPoper
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.user.TitleEmail`)}
                                                content={translate(`pos.user.ConstentEmail`)}
                                                icon={<b>?</b>}
                                            />
                                        }
                                    />
                                </ Box>
                            </Fragment>
                        }


                        <Box mt={3}>
                            <CustomTextField
                                className={classes.number}
                                type='number'
                                id="filled-basic"
                                label={translate(`pos.user.phonenumber`)}
                                value={textValue.phoneNumber}
                                onChange={textOnChange('phoneNumber')}
                                style={{ width: 500 }}
                                endDom={
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.user.TitlePhoneNumber`)}
                                        content={translate(`pos.user.ConstentPhoneNumber`)}
                                        icon={<b>?</b>}
                                    />
                                }
                            />
                        </ Box>
                        <Box mt={3}>
                            <CustomTextField
                                id="filled-basic"
                                label={translate(`pos.user.company`)}
                                value={textValue.organisation}
                                onChange={textOnChange('organisation')}
                                style={{ width: 500 }}
                                endDom={
                                    <CustomPoper
                                        open={openPoper}
                                        anchorEl={anchorEl}
                                        handleClick={handleClickOpenPoper}
                                        handleClose={handleClosePoper}
                                        title={translate(`pos.user.TitleCompany`)}
                                        content={translate(`pos.user.ConstentCompany`)}
                                        icon={<b>?</b>}
                                    />
                                }
                            />
                        </ Box>
                        <hr style={{ marginTop: "30px", marginBottom: '30px', borderTopColor: ' #e6e6eb' }} />
                        {
                            (roleUser === "Sysadmin" || permissions.functionAction.find(value => value.function === 'Admin rights/functions' && value.isUpdate)) &&
                            <Fragment>
                                <Box pt={1} pb={0} mt={1} >
                                    <SelectBox
                                        label={translate(`pos.user.role`)}
                                        value={<Typography className={classes.TexTSelect} >{role}</Typography>}
                                        open={openRole}
                                        handleClick={handleClickOpenRole}
                                    >
                                        {
                                            dataRole.map((role, index) => (
                                                <Box hidden={role.name === "Sysadmin" ? true : false} key={index} className={classes.boxBoder}>
                                                    <ListItem style={{ padding: '8px' }} button onClick={() => onChangeRole(role)}>
                                                        <Typography className={classes.TexTSelect}  >{role.name}</Typography>
                                                    </ListItem>
                                                </Box>
                                            ))
                                        }
                                    </SelectBox>
                                </Box>
                                <Card style={{ marginTop: "1em", height: 96, borderRadius: '0' }}  >
                                    <CardContent>
                                        <Typography className={classes.TitleLevel} gutterBottom>
                                            <Box display='flex' alignItems="center">
                                                {translate(`pos.user.level`)} : {countcluster === 0 ? "" :
                                                    <Box ml={1} p={0.5} mr={1} width="100px" height="30" className={classes.borderLevel}>
                                                        <Box display='flex' alignItems="center">
                                                            <Typography className={classes.textLevel}>
                                                                {countcluster + " " + translate(countcluster <= 1 ? `pos.user.cluster` : `pos.user.clusters`).toUpperCase()}
                                                            </Typography>
                                                            <Box flexGrow={1} display='flex' justifyContent='flex-end'>
                                                                <CustomPoperUser open={openPoper}

                                                                    anchorEl={anchorEl}
                                                                    handleClick={handleClickOpenPoper} handleClose={handleClosePoper}
                                                                    title={translate(`pos.user.cluster`)}
                                                                    content={cluster.join(", ")}
                                                                    icon={<b>i</b>} />
                                                            </Box>
                                                        </Box>
                                                    </Box>}
                                            </Box>
                                        </Typography>

                                        <Button variant="contained"
                                            style={{ marginTop: '10px' }}
                                            disabled={role === "Sysadmin" ? true : false}
                                            size="small"
                                            color="primary"
                                            onClick={handleOpenDialog}
                                            endIcon={<img alt='' src={edit} style={{ width: "20px", height: 20, marginLeft: "5px" }} />}
                                        > <Typography className={classes.textbtnLevel}>{translate(`pos.user.changelevel`)}</Typography></Button>

                                    </CardContent>
                                    <ChangeLevel
                                        open={openDialog}
                                        handleCancel={() => {
                                            setOpenDialog(false)
                                            setEntities(cancel)
                                            setExpandAll(false)

                                        }}
                                        handleSave={() => {
                                            setOpenDialog(false)
                                            handleSaveShowCluster()
                                            setExpandAll(false)

                                        }}
                                        entities={entities}
                                        setEntities={setEntities}
                                        expandAll={expandAll}
                                        setExpandAll={setExpandAll}
                                    />
                                </Card>
                                <Box pt={1} pb={0} mt={1} >
                                    <SelectBox
                                        label={translate(`pos.user.language`)}
                                        value={<Box display='flex' alignItems='center' style={{ marginTop: '-5px' }}>
                                            <img alt='' src={`https://www.countryflags.io/${languagecode}/flat/32.png`} />
                                            <Box ml={2} ><Typography className={classes.TexTSelect} >{language}</Typography></Box>
                                        </Box>
                                        }
                                        open={openLanguage}
                                        handleClick={handleClickOpenLanguage}
                                    >
                                        {
                                            dataLanguage.map((Language, index) => (
                                                <Box key={index} className={classes.boxBoder}>
                                                    <ListItem style={{ padding: '8px' }} button onClick={() => onChangeLanguage(Language)}>
                                                        <img alt='' src={`https://www.countryflags.io/${Language.code}/flat/32.png`} />
                                                        <Box ml={2} ><Typography className={classes.TexTSelect}  >{Language.name}</Typography></Box>
                                                    </ListItem>
                                                </Box>
                                            ))
                                        }
                                    </SelectBox>
                                </Box>

                            </Fragment>
                        }

                        <Card style={{ marginTop: "1em" }} className={classes.borderUpImange}   >
                            <Grid container style={{ marginTop: "1em" }} item xs={12} sm={12} xl={12} lg={12} >
                                <Grid >
                                    <CardContent>
                                        <Avatar src={baseApiUrl + image} className={classes.large} />
                                    </CardContent>

                                </Grid>
                                <Grid>
                                    <CardContent>
                                        <Typography className={classes.TitleImage} gutterBottom>
                                            {translate(`pos.user.changeimage`)}
                                        </Typography>
                                        <Box>
                                            <input accept="image/*" className={classes.display} id="contained-button-file" type='file' onChange={handleChooseImage} />
                                            <label htmlFor="contained-button-file">
                                                <Button className={classes.borderImage} component="span">
                                                    <Typography className={classes.textBtnImage} > {translate(`pos.user.uploadphoto`)}</Typography>
                                                </Button>
                                            </label>
                                        </Box>
                                    </CardContent>
                                </Grid>
                            </Grid>
                        </Card>
                        <hr style={{ marginTop: "30px", borderTopColor: ' #e6e6eb' }} />
                        <Box display='flex' justifyContent='flex-end'>
                            <Box mr='auto' display='flex'>
                                <Typography className={classes.textRequiredStar} >{translate(`pos.user.star`)}</Typography>
                                <Typography className={classes.textRequired} >{translate(`pos.user.required`)}</Typography>

                            </Box>
                        </Box>
                        <Box display='flex' justifyContent='flex-end'>
                            <Box display='flex' alignItems='flex-end' mt={3} >
                                <TextButton style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/users" }}/>
                                  
                                <Button variant="contained" color='primary' size='large' onClick={handleSubmitUser}

                                    disabled={textValue.username && textValue.firstName && textValue.lastName && textValue.email !== '' ? false : true}
                                >
                                    {loading ? (
                                        <CircularProgress
                                            size={20}
                                            thickness={2}
                                            color='inherit'
                                        />
                                    ) : <Typography className={classes.btnCreate}> {translate(`pos.user.save`)}</Typography>}

                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>

            </Box>
        </Box >
    )

}
export default EditUser

